import { SignupForm } from '@/components/auth/signup-form'

export default function SignUpPage() {
  return (
    <div className='flex min-h-screen w-full items-center justify-center bg-background'>
      <SignupForm />
    </div>
  )
}
